var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('b-row',{staticClass:"justify-content-lg-between",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"copyright text-center text-lg-right text-muted"},[_vm._v(" © "+_vm._s(_vm.year)+" Release Management System ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }